module.exports = __webpack_public_path__ + "static/media/file-times.50c76e9d.svg";